import React from "react";
import { Link } from "@quintype/components";
import { object, bool, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Headline from "../../atoms/Headline";

import "./storytitleInfo.m.css";

const StoryTitleInfo = ({ story, iconLiveBlog, summary, publisherAttributes }) => {
  const isClosed = get(story, ["metadata", "is-closed"], false);
  const subHeadlineStyle = `${publisherAttributes.lang}-sub-headline`;

  const getSubjectTopicTag = () => {
    if (!publisherAttributes.subject_topic_linked_entity) {
      const subjectTopicTag =
        story.tags && story.tags.length > 0 ? story.tags.find((tag) => tag.type === "subject-topic-tag") : null;
      return subjectTopicTag;
    }

    const subjectTopicAttributeId = get(story, ["metadata", "story-attributes", "subjecttopic", "0", "id"], null);
    const subjectTopicLinkedEntity =
      story["linked-entities"] && story["linked-entities"].length > 0 && subjectTopicAttributeId
        ? story["linked-entities"].find((item) => item.id === subjectTopicAttributeId)
        : null;
    return subjectTopicLinkedEntity;
  };

  return (
    <div styleName="wrapper" data-testid="section" className="story-title-info">
      {iconLiveBlog && !isClosed && <span styleName="live-text" />}
      <div styleName="entity-section-wrapper" className="print-entity-section-wrapper">
        {getSubjectTopicTag() && (
          <Link href={"/topic/" + getSubjectTopicTag().slug} className="topic-tag" data-testid="entity-tag">
            {getSubjectTopicTag().name}
          </Link>
        )}
        {story.subheadline && (
          <Headline
            text={story.subheadline}
            headlineType={16}
            headerLevel={2}
            className={`section-name ${iconLiveBlog ? "live-blog-section-name" : ""}`}
            styleName={subHeadlineStyle}
          />
        )}
      </div>
      <div>
        <Headline
          text={story.headline}
          headlineType={9}
          headerLevel={1}
          className={`story-headline ${publisherAttributes.lang}-story-headline`}
        />
      </div>
      {summary && <div dangerouslySetInnerHTML={{ __html: summary }} styleName="summary" />}
    </div>
  );
};

StoryTitleInfo.propTypes = {
  story: object.isRequired,
  iconLiveBlog: bool,
  summary: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(StoryTitleInfo);
